<template>
    <img class="w-16 aspect-square object-cover bg-zinc-100" :src="image" :alt="imageAlt" :loading="imageLoading" />
</template>

<script>
export default {
    name: 'ImageTile',
    props: {
        image: {
            required: false,
            type: String,
            default: null,
        },
        imageAlt: {
            required: false,
            type: String,
            default: '',
        },
        imageLoading: {
            required: false,
            type: String,
            default: 'lazy',
        },
    },
};
</script>
